import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import App from './app'

const RootRedirect = () => {
	const location = useLocation()
	return <Navigate to={Object.assign({}, location, { pathname: `/migration/:gid` })} replace />
}

class Main extends React.Component {
	render() {
		return <Routes>
			<Route path={`/migration/:gid`} element={<App />}/>
			<Route path="/" element={<RootRedirect />}/>
		</Routes>
	}
}

export default Main
